import { Controller } from 'stimulus'
import { notificationText } from '../../notifications/payload'

export default class BaseNotificationController extends Controller {

  // COMMON

  // Mark a notification as read
  markAsRead(event) {
    const unreadNotification = event.currentTarget
    if (unreadNotification.classList.contains('unread')) {
      const notificationId = unreadNotification.dataset.id
      this._buildRequest('/notifications/mark_as_read', 'PATCH', { notification_id: notificationId })
        .then(response => {
          if (response.ok) {
            unreadNotification.classList.remove('unread')
            this._decreaseCounter()
          }
        })
    }
  }

  // The list is only repainted if the server actually saved the change
  markAllAsRead(event, list) {
    if (event) event.preventDefault()

    return this._buildRequest('/notifications/mark_all_as_read', 'PATCH', {})
      .then(response => {
        if (!response.ok) return false

        list.querySelectorAll('.unread').forEach(notif => notif.classList.remove('unread'))
        this._resetCounter()
        return true
      })
      .catch(() => false)
  }

  // Private

  // NOTIFICATION NAVBAR — Create new notification to append
  _insertNavNotification(notification) {
    const newNotification = document.createElement('div')

    newNotification.dataset.id = notification.id
    newNotification.classList.add('notification')

    if (!notification.read) newNotification.classList.add('unread')
    if (!notification.read) newNotification.dataset.action = 'mouseover->notifications--navbar#markAsRead'

    const localizedDate = new Date(notification['created_at']).toLocaleDateString() + ' ' + new Date(notification['created_at']).toLocaleTimeString()

    newNotification.innerHTML = `<div class="notification-time">
                                    <span>${localizedDate}</span>
                                  </div>
                                  ${notification['informations']['bullet']}
                                  ${notificationText(notification['informations'])}`
    return newNotification
  }


  // Update the counter
  // countTarget is defined in the child controller
  _increaseCounter() {
    this._updateCounter(count => count + 1)
  }

  _decreaseCounter() {
    this._updateCounter(count => count - 1)
  }

  _resetCounter() {
    this._updateCounter(() => 0)
  }

  // Single source of truth for the bell counter and the document title
  _updateCounter(compute) {
    const counter = document.getElementById('notif-nb')
    if (!counter) return

    const newCount = Math.max(compute(parseInt(counter.dataset.unread, 10) || 0), 0)
    counter.dataset.unread = newCount
    counter.classList.toggle('d-none', newCount <= 0)

    const baseTitle = this._baseDocumentTitle(counter)
    document.title = newCount > 0 ? `(${newCount}) ${baseTitle}` : baseTitle
  }

  // Pages that don't set @meta_title have no data-title, which used to write
  // the string "undefined" in the tab. Fall back on the title already displayed.
  _baseDocumentTitle(counter) {
    if (!counter.dataset.title) {
      counter.dataset.title = document.title.replace(/^\(\d+\)\s*/, '')
    }
    return counter.dataset.title
  }

  _buildGetRequest(path) {
    return fetch(path, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
    })
  }

  _buildRequest(path, method, body) {
    return fetch(path, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      method: method,
      body: JSON.stringify(body)
    })
  }

  _showSpinner() {
    const spinnerContainer = document.createElement('div')
    spinnerContainer.classList.add('loading-spinner-container-sm')
    spinnerContainer.innerHTML = '<div id="loading-spinner"></div>'
    return spinnerContainer
  }

  _deleteSpinner() {
    document.querySelector('.loading-spinner-container-sm').remove()
  }
}
